module.exports = __webpack_public_path__ + "media/country_flags/to-0c8957ad.png";